<template lang="pug">
#sub-empresa-tabela-gestao-contrato-originacao
    .tabela-gestao-contrato-originacao__tabela
        el-table(
            :data='tabelaData',
            v-loading='carregando',
            stripe,
            :default-sort='{ prop: "date", order: "descending" }',
            @sort-change='sortChangeRequest',
            style='width: 100%'
        )
            el-table-colunm(
                v-for='column in tabelaData.itens',
                :key='column.idDenuncia',
                :prop='column',
                :label='$t("denuncia.table.columns" + column)'
            )

            el-table-column(
                prop='idDenuncia',
                width=150,
                :label='$t("denuncia.table.columns.idConsulta")',
                align='center'
            )

            el-table-column(
                prop='listaValor',
                :label='$t("denuncia.table.columns.value")'
            )

            el-table-column(
                prop='dataConsulta',
                width=160,
                :label='$t("denuncia.table.columns.date")'
            )

            el-table-column(
                prop='usuario',
                width=150,
                :label='$t("denuncia.table.columns.user")'
            )

            el-table-column(
                prop='emailUsuario',
                width=360,
                :label='$t("denuncia.table.columns.mail")'
            )

            el-table-column(
                prop='resultado',
                sortable,
                width=150,
                :label='$t("denuncia.table.columns.result")'
            )

            el-table-column(
                :label='$t("denuncia.table.columns.actions")',
                width=100,
                align='center'
            )
                .template.d-flex.justify-content-center.tabela-gestao-icone(
                    slot-scope='scope'
                )
                    el-dropdown.action-button(trigger='click')
                        span.el-dropdown-link
                            i.mdi.mdi-dots-vertical
                        el-dropdown-menu(slot='dropdown')
                            el-dropdown-item(
                                icon='el-icon-view',
                                @click.native='visualizarDenuncia(scope.row)'
                            ) {{ $t('denuncia.table.actions.view') }}

            template(slot='empty')
                el-empty(:description='$t("denuncia.words.empty")')

    .tabela-gestao-contrato-originacao__paginacao
        span.pagina
            | {{ paginacao.total }} {{ paginacao.total > 1 ? $t('denuncia.words.consults') : $t('denuncia.words.consult') }}

        el-pagination(
            background,
            :page-size='paginacao.itensPorPagina',
            :pager-count='5',
            :current-page.sync='paginacao.pagina + 1',
            layout='prev, pager, next',
            :total='paginacao.total',
            @current-change='mudarPagina'
        )
</template>

<script>
import ModalDetalheAnalise from '@/components/contratosOriginacao/ModalDetalheAnalise.vue';
import { mapGetters } from 'vuex';

export default {
    name: 'DenunciaTabelaGestao',
    components: {
        ModalDetalheAnalise
    },
    props: {
        tabelaData: {
            type: Array,
            required: true
        },
        paginacao: {
            type: Object,
            required: true
        },
        carregando: {
            type: Boolean,
            required: false
        }
    },
    computed: {
        ...mapGetters(['usuarioLogado'])
    },
    methods: {
        mudarPagina(novaPagina) {
            this.$emit('mudarPagina', novaPagina - 1);
        },
        sortChangeRequest(column) {
            const order = {
                prop: column.prop,
                order: column.order === 'ascending' ? 'asc' : 'desc'
            };

            this.$emit('ordenarTabela', order);
        },
        visualizarDenuncia(denuncia) {
            this.$router.push({
                name: 'visualizarDenuncia',
                params: {
                    id: denuncia?.idDenuncia || 0,
                    row: denuncia
                }
            });
        }
    }
};
</script>
<style lang="scss">
#sub-empresa-tabela-gestao-contrato-originacao {
    box-shadow: 0 0 10px rgb(0 0 0 / 10%);
    border-radius: 10px;

    .el-table {
        border-top-right-radius: 11px;
        border-top-left-radius: 11px;
        min-height: 240px;

        thead.has-gutter {
            height: 67px;

            th.el-table__cell {
                background-color: #fbfbfb;
            }
        }
    }

    .el-table__cell {
        font-size: 12px;
    }

    .is-leaf {
        font-size: 13px;
    }

    .status-processamento {
        max-width: 148px;
        word-break: break-word;
        font-size: 13px;
        line-height: 17px;
    }

    .tabela-gestao-contrato-originacao__paginacao {
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: var(--white);
        padding: 14px 11px;
        border-bottom-left-radius: 11px;
        border-bottom-right-radius: 11px;

        .pagina {
            color: var(--primary);
            font-weight: 600;
        }
    }

    .tabela-gestao-icone {
        i {
            font-size: 23px;
            cursor: pointer;
        }
    }
}
</style>
